// SEE: https://github.com/getslick/api.core/blob/staging/docs/pos.md

export const POS_CODE = Object.freeze({
  waiting: 'POS100',
  success: 'POS200',
  failure: 'POS300',
});

export const POS_FLOW_CODE = Object.freeze({
  ...POS_CODE,
  // make sure the following aren't already part of POS_CODE
  init: 'reader-init-error',
  status: 'reader-status-error',
});
